// extracted by mini-css-extract-plugin
module.exports =  {"accessibilityAlert":"_accessibilityAlert--ktFfw","spin":"_spin--2APwf","progressDots":"_progressDots--2xR4D"};